import {PageOpenIn} from "@enums/PageOpenIn";
import {ToRef} from "@vue/runtime-core";
import {ref} from "vue";

export default class ViewRulesController {
  private static instance?: ViewRulesController;
  public openIn: ToRef<PageOpenIn> = ref(PageOpenIn.PAGE);
  public insidePopup: ToRef<boolean> = ref(false);
  public url: ToRef<string> = ref(import.meta.env.VITE_URL_RULES);

  public static of() {
    if (typeof ViewRulesController.instance === 'undefined') ViewRulesController.instance = new ViewRulesController();

    return ViewRulesController.instance;
  }
}
